module.exports = __webpack_public_path__ + "img/snorkeling-13.1e87fde2.jpeg";